import React, { forwardRef } from "react";

import {
  Box,
  Flex,
  Image,
  Spacer,
  Text,
  HStack,
} from "@chakra-ui/react";

import mprjlogoCompleto from "../../../img-docs/mprjlogoCompleto.png";
import { AuditoriaRelatorioGrupos } from "../AuditoriaRelatorioGrupos";

export const ComponentToPrintAuditoriaServico = forwardRef(
  ({ relatorio }, ref) => {
    const registros = relatorio?.registros || [];

    const [dataEmitido, horaEmitido] = (relatorio?.geradoEm || "").split(" - ");

    return (
      <Box display="block" ref={ref}>
        <table>
          <thead>
            <tr>
              <td>
                <Box height="20px" />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Box display="break-page" px={10}>
                  <Box borderBottom="2px solid #7A1F2B" pb={4} mb={4}>
                    <Flex alignItems="center" justifyContent="center">
                      <Image src={mprjlogoCompleto} h="110px" />
                    </Flex>

                    <Text
                      textAlign="center"
                      fontWeight={700}
                      fontSize="16px"
                      color="#7A1F2B"
                      mt={2}
                    >
                      {(
                        relatorio?.titulo ||
                        "Relatório de Auditoria - Serviço de Acolhimento"
                      ).toUpperCase()}
                    </Text>
                  </Box>

                  {registros.length === 0 && (
                    <Text mt={6} color="#6B6C71">
                      Nenhum registro encontrado.
                    </Text>
                  )}

                  {registros.map((registro, indice) => {
                    const total = (registro.eventos || []).reduce(
                      (soma, evento) => soma + (evento.campos?.length || 0),
                      0,
                    );

                    return (
                      <Box
                        key={registro.registroDk}
                        mt={indice > 0 ? 10 : 0}
                        css={indice > 0 ? { breakBefore: "page" } : undefined}
                      >
                        <Flex
                          justifyContent="space-between"
                          border="1px solid #D7D8DE"
                          borderRadius="6px"
                          p={4}
                        >
                          <Box>
                            <Text fontSize="11px" color="#6B6C71">
                              SERVIÇO DE ACOLHIMENTO
                            </Text>
                            <Text fontWeight={700} fontSize="16px">
                              {registro.nomeFantasia || registro.nome}
                            </Text>
                            {registro.nomeSocial && (
                              <Text fontSize="12px">
                                Nome Social: {registro.nomeSocial}
                              </Text>
                            )}
                            <Text fontSize="12px">
                              <Text as="b">Situação atual: </Text>
                              {registro.situacao}
                            </Text>
                            <Text fontSize="12px">
                              <Text as="b">Promotoria: </Text>
                              {registro.promotoria}
                            </Text>
                          </Box>
                          <Box textAlign="right" flexShrink={0}>
                            <Text fontSize="12px" fontWeight={700} whiteSpace="nowrap">
                              Emitido em:
                            </Text>
                            <Text fontSize="12px" whiteSpace="nowrap">
                              {dataEmitido} às {horaEmitido}
                            </Text>
                            <Text fontSize="12px" fontWeight={700} mt={2} whiteSpace="nowrap">
                              Alterações no período:
                            </Text>
                            <Text fontSize="12px" whiteSpace="nowrap">
                              {total} registro(s)
                            </Text>
                          </Box>
                        </Flex>

                        <AuditoriaRelatorioGrupos eventos={registro.eventos} />
                      </Box>
                    );
                  })}
                </Box>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <Box height="80px" />
              </td>
            </tr>
          </tfoot>
        </table>

        <Flex
          position="fixed"
          bottom={0}
          pt="10px"
          pb="10px"
          w="100%"
          px="15px"
          backgroundColor="#FFF"
          borderTop="1px solid #D7D8DE"
          zIndex={100}
        >
          <HStack spacing="35px">
            <Text>{dataEmitido}</Text>
            <Text>-</Text>
            <Text>{horaEmitido}</Text>
          </HStack>
          <Spacer />
          <Text id="pageForPrint">Página</Text>
        </Flex>
      </Box>
    );
  },
);
